import { useStore } from 'dg-web-shared/lib/Flux';
import * as LayoutState from '../state/LayoutState';
import { responsiveVariant } from '../utils/responsiveVariant';
import { css } from '@emotion/css';

export interface LayoutProps {
    children?: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));

    return (
        <div>
            <div
                className={css([
                    {
                        height: '100%',
                    },
                    responsiveVariant(storeState) === 'Mobile' && {
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        overflow: 'hidden',
                    },
                ])}
            >
                {children}
            </div>
        </div>
    );
}
